import styled from 'styled-components';
import { media } from '../../../style/media';

export const Container = styled.div`
  padding: 40px;
  max-width: 1600px;
  margin: 0 auto;

  ${media.s`
    padding: 20px;
  `}
`;

export const PageHeader = styled.div`
  margin-bottom: 32px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 20px;
  flex-wrap: wrap;
`;

export const HeaderLeft = styled.div`
  flex: 1;
  min-width: 250px;
`;

export const PageTitle = styled.h1`
  font-size: 32px;
  font-weight: 700;
  color: #111827;
  margin: 0 0 8px 0;

  ${media.s`
    font-size: 24px;
  `}
`;

export const PageDescription = styled.p`
  font-size: 14px;
  color: #6b7280;
  margin: 0;
`;

export const EmptyState = styled.div`
  text-align: center;
  padding: 40px 20px;
  color: #6b7280;

  i {
    font-size: 48px;
    color: #d1d5db;
    margin-bottom: 12px;
  }

  p {
    font-size: 14px;
    margin: 0;
  }
`;

export const LoadingSpinner = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 12px;
  padding: 20px;
  color: #6b7280;

  i {
    font-size: 24px;
    animation: spin 1s linear infinite;
  }

  @keyframes spin {
    from {
      transform: rotate(0deg);
    }
    to {
      transform: rotate(360deg);
    }
  }
`;

